import { useHistory } from "react-router-dom";
import { PublicPageHeader } from "../../../components/headers/header-public-page/header-public-page";
import { Navbar } from "../../../components/nav";
import { PedidosSemEntregadorList } from "./components/pedidos-sem-entregador-list";
import { useStyles } from "./pedidos-sem-entregador-page-styles";
import { Button } from "@material-ui/core";
import { OkIcon } from "../../../components/icons/ok-icon";

const PedidosSemEntregadorPage = () => {
    const classes = useStyles();
    const history = useHistory();
    return (
        <>
            <PublicPageHeader topOpacity="0.8" />
            <div className={classes.divRoot}>
                <Navbar buttonBack voltar={() => history.replace('/entregas-pendentes')} titulo={'Buscar pedidos para entrega'} />
                <div className={classes.root}>
                    <PedidosSemEntregadorList />
                </div>
                <div className={classes.divButton}>
                    <Button
                        onClick={() => history.replace('/')}
                        variant="contained"
                        color="primary"
                        fullWidth
                        size="large"
                    >
                        <OkIcon tipo="BUTTON_PRIMARY" />
                        Confirmar
                    </Button>
                </div>
            </div>
        </>
    )
}

export default PedidosSemEntregadorPage;
